import { URLS } from "@app/shared/urls";
import { PageHeader } from "@design-system/components";
import { trans } from "@mongez/localization";
import { FinancialInformationTabs } from "../components";

export function FinancialInformationPage() {
  return (
    <section className="relative min-h-dvh bg-[#f7f9fc] pb-12 text-white lg:pb-24">
      <PageHeader
        translationKey="financialInformation"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("financialInformation") },
        ]}
      />
      <FinancialInformationTabs />
    </section>
  );
}
